import { Fragment, useState, useContext } from "react";
import { format } from "date-fns";
import { BsArrowLeft } from "react-icons/bs";
import parse from "html-react-parser";

import Image from "components/image/image.component";

import { TicketsContext } from "src/contexts/tickets.context";

import useTranslate from "src/hooks/use-translate";

import { formatDate } from "utils/date.utils";

import "./ticket-details.style.scss";
import RichTextEditor from "../richt-text-editor/rich-text-editor.component";

const organizeRequestedBy = (value) => {
	return (
		<>
			{value?.company && <span>{value.company} / </span>}
			{value.user}
		</>
	);
};

const Field = ({ label, data }) => {
	return (
		<p
			className="size400 border--bottom padding-xxxl--right padding-s--bottom"
			// style={{ width: "fit-content" }}
		>
			<span className="w500 padding-l--right">{label}</span> {data}
		</p>
	);
};

const TicketDetails = ({ goBack, ticketId }) => {
	const { closeTicket, getTicketById, respond } = useContext(TicketsContext);

	const t = useTranslate("TicketDetails");

	const [isTextEditorVisible, setIsTextEditorVisible] = useState(false);
	const [ticket, setTicket] = useState(getTicketById(ticketId));
	const { id, requestedBy, subject, tId, status, createdAt, lastActivity, assignedTo, messages } =
		ticket;

	const handleWriteReplyButton = () => {
		setIsTextEditorVisible(true);
	};

	const handleCloseButton = () => {
		closeTicket(id);
		setTicket((oldValue) => {
			return { ...oldValue, status: "CLOSED" };
		});
	};

	const handleSendRespond = (text) => {
		respond(id, text);
		setIsTextEditorVisible(false);
	};

	return (
		<div className="ticket-details-container flex flex--column">
			<div name="header" className="flex flex--center-items padding-xs--bottom border--bottom">
				<BsArrowLeft onClick={goBack} size={"2.4rem"} className="pointer" />
				{/* </span> */}
				<p className="size500 w600 padding-l--left">{subject}</p>
				<p className="size500 padding-m--inline">{`[${tId}]`}</p>
				<span className="border round-corners  padding-l--inline padding-xs--block">{status}</span>
				<div className="flex flex--grow flex--end-content gap-m padding-l--right">
					<button
						onClick={handleWriteReplyButton}
						disabled={status === "CLOSED"}
						className={`btn btn--hover size400 w600 padding-l--inline padding-xs--block ${
							status === "CLOSED" && "btn--disabled"
						}`}
					>
						{t("Write a Reply")}
					</button>
					<button
						onClick={handleCloseButton}
						disabled={status === "CLOSED"}
						className={`btn btn--hover btn--red-text size400 w600 padding-l--inline padding-xs--block ${
							status === "CLOSED" && "btn--disabled"
						}`}
					>
						{t("Close Ticket")}
					</button>
				</div>
			</div>
			<div name="sub-header" className="padding-xxxl--right padding-l--top margin-xxxl--top">
				<div className="flex flex--start-items gap-xxxl">
					<div name="left">
						<Field label={"Requested by"} data={organizeRequestedBy(requestedBy)} />
						<div className="margin-xxl--top">
							<Field label={"Assigned to"} data={assignedTo} />
						</div>
					</div>
					<div className="flex--grow" />
					<Field label={"Last Activity"} data={lastActivity} />
					<Field label={"Created Date"} data={createdAt} />
				</div>
			</div>
			<div
				name="details"
				className="flex--grow padding-xxxl--right margin-xxl--top scroll-bar scroll-bar--overflow"
			>
				{messages.map(({ sender, date, message }, index) => {
					return (
						<Fragment key={index}>
							<div name="header" className="flex flex--center-items border--bottom gap-xl">
								<Image name={sender.user} color={sender.color} size={"3rem"} round />
								<p className="size400 w600">
									{sender.user} {sender?.company && <span>| {sender.company}</span>}
								</p>
								<span className="flex--grow" />
								<p>{format(new Date(date.toString()), "dd/mm/yyyy HH:mm")}</p>
							</div>
							<div name="message" className="padding-l--top padding-xxxl--bottom">
								{parse(message)}
							</div>
						</Fragment>
					);
				})}
				{isTextEditorVisible && (
					<RichTextEditor
						dismiss={() => {
							setIsTextEditorVisible(false);
						}}
						save={handleSendRespond}
					/>
				)}
			</div>
		</div>
	);
};

export default TicketDetails;
